import Images from "../assets/Image";
import FileName from "../broucherPdf/filePdf";

export const SOCIAL_LINKS = {
  linkedin: "https://www.linkedin.com/company/116094432/admin/dashboard/",
  youtube: "https://www.youtube.com/@usppackagingsolutionspvt.l8055",
};

export const IMAGE_LIST = [
  {
    path: Images?.uspstream1,
    imageName: "USP STREAMLINE PLUS",
    fileName: "USP STREAMLINE PLUS.pdf",
    downloadFile: FileName?.usp_STREAMLINE_PLUS,
    fileUrl: "/product/uspStreamlinePlus",
  },
  {
    path: Images?.uspstream2,
    imageName: "USP JETSTREAM II",
    fileName: "USP JETSTREAM II.pdf",
    downloadFile: FileName?.usp_JETSTREAM_II,
    fileUrl: "/product/uspJetStream2",
  },
  {
    path: Images?.uspstream3,
    imageName: "USP STREAMLINE 4SP",
    fileName: "STREAMLINE 4SP.pdf",
    downloadFile: FileName?.STREAMLINE_4sp,
    fileUrl: "/product/uspStreamLine4SP",
  },
  {
    path: Images?.uspstream4,
    imageName: "USP A-2120",
    fileName: " USP A-2120.pdf",
    downloadFile: FileName?.usp_a2120,
    fileUrl: "/product/uspA2120",
  },
];
export const HIGH_RESOLUTION = [
  {
    path: Images?.uspstream5,
    imageName: "USP COPILOT 128",
    fileName: "USP COPILOT 128.pdf",
    downloadFile: FileName?.usp_COPILOt_128,
    fileUrl: "/product/Copulot128",
  },
  {
    path: Images?.uspstream6,
    imageName: "USP COPILOT 256",
    fileName: "USP COPILOT 256.pdf",
    downloadFile: FileName?.usp_COPILOt_256,
    fileUrl: "/product/copilot256",
  },
  {
    path: Images?.uspstream7,
    imageName: "USP COPILOT MAX 400",
    fileName: "USP COPILOT 400.pdf",
    downloadFile: FileName?.usp_COPILOt_400,
    fileUrl: "/product/copilotMax400",
  },
  {
    path: Images?.uspstream8,
    imageName: "USP COPILOT MAX 512i",
    fileName: "USP CoPilot MAX 512i TURBO.pdf",
    downloadFile: FileName?.usp_CoPilot_MAX_512i_TURBO,
    fileUrl: "/product/copilotMax512iTurbo",
  },
  {
    path: Images?.uspstream9,
    imageName: "USP COPILOT MAX TURBO",
    fileName: "USP CO PILOT MAX TURBO.pdf",
    downloadFile: FileName?.usp_CO_PILOT_MAX_TURBO,
    fileUrl: "/product/copilotMaxTurbo",
  },
  {
    path: Images?.uspstream10,
    imageName: "USP COPILOT MAX LT",
    fileName: "USP COPILOT MAX LT.pdf",
    downloadFile: FileName?.usp_COPILOT_MAX_LT,
    fileUrl: "/product/copilotMaxlt",
  },
  {
    path: Images?.uspstream11,
    imageName: "USP COPILOT GEMINI",
    fileName: "USP COPILOT GEMINI.pdf",
    downloadFile: FileName?.Co_Pilot_Gemini,
    fileUrl: "/product/copilotGemini",
  },
];
export const LASER_PRINTER = [
  {
    path: Images?.uspstream18,
    imageName: "USP CO2 LASER",
    fileName: "USP CO2 LASER.pdf",
    downloadFile: FileName?.usp_CO2_Laser,
    fileUrl: "/product/uspCo2Laser",
  },
  {
    path: Images?.uspstream12,
    imageName: "USP FIBER LASER",
    fileName: "USP FIBER LASER.pdf",
    downloadFile: FileName?.usp_FIBER_LASER,
    fileUrl: "/product/uspFiberLaser",
  },
];
